<div *ngIf="lineItem" class="line-item-wrapper">
  <div class="request-authority-content-row">
    <div class="line-item-header">
      <div class="request-authority-content-column line-item-count">
        Line {{lineItem.lineNumber}}
      </div>
    </div>
  </div>
  <div class="line-item-row">
    <div class="line-item-column col-operating">
      <label>Operating From</label>
      <strong> {{ lineItem.fromPoint.displayName }} </strong>
      {{ lineItem.fromPoint.location.track.name }}
    </div>
    <div class="line-item-column col-track">
      <label>Operating To </label>

      <strong>{{lineItem.toPoint.displayName }}</strong>
      {{ lineItem.toPoint.location.track.name }}
    </div>
  </div>
  <div class="line-item-row">
    <div class="line-item-column col-operating">
      <label> Direction </label>
      <strong>{{Direction[lineItem.direction]}}</strong>
    </div>

    <div class="line-item-column col-track">
      <label> Operate On </label>
      <strong>{{lineItem?.operateOn }}</strong>
    </div>
  </div>
</div>